/*************************************************************
@Purpose    :   Error messages
*************************************************************/
export const MSG = {
	REQUIRED_QUERY: "*Query is required",
	REQUIRED_CODE: "*Code is required",
	REQUIRED_TYPE: "*Type is required",
	REQUIRED_LOGO: "*Logo is required.",
	REQUIRED_FIELD: "Field is required",
	REQUIRED_ONLY_LATTIN_LETTERS: "*Name can only contain Latin letters",
	REQUIRED_COLOR: "*Color is required",
	REQUIRED_EMAIL: "*Email is required.",
	REQUIRED_VALUE: "*Value is required.",
	REQUIRED_SUBJECT: "*Subject is required",
	LOGOUT_SUCCESS: "Logged out successfully",
	REQUIRED_COLUMNS: "*Columns are required.",
	REQUIRED_POSITION: "*Position is required.",
	REQUIRED_PASSWORD: "*Password is required.",
	REQUIRED_EMAIL_KEY: "*Email key is required",
	REQUIRED_LAST_NAME: "*Last name is required.",
	REQUIRED_VALID_FIRSTNAME: "*First name must be at most 15 characters",
	REQUIRED_VALID_LASTNAME: "*Last name must be at most 15 characters",
	REQUIRED_HELP_TOPIC_NAME: "*Please enter topic name",
	REQUIRED_VALID_HELP_TOPIC:
		"*Help topic name should contain at least one letter",
	REQUIRED_IMAGE: "*Please upload image",
	REQUIRED_EMOJI: "*Please select emoji",
	REQUIRED_TERMS_AND_CONDITIONS: "*Terms & Conditions are required",
	REQUIRED_COUPONS_CODE: "*Coupon Code is required",
	PROVIDE_VALID_COUPON_CODE:
		"*Special characters and spaces are not allowed in coupon code",
	REQUIRED_VALID_DISCOUNT_AMOUNT: "*Discount amount allows only numbers",
	REQUIRED_DISCOUNT_AMOUNT: "*Discount is required",
	REQUIRED_DISCOUNT_LESS_THAN_100: "*Discount must be less than 100",
	VOUCHER_CODE_MAX_LIMIT: "*Code Must be less than or equal to 8 characters",
	REQUIRED_DISCOUNT_GREATER_THAN_0: "*Discount amount must be greater than 0",
	REQUIRED_VALID_MAXIMUM_DISCOUNT: "*Maximum discount allows only numbers",
	REQUIRED_VALID_OPA_COMISSION: "* Please enter a valid Opa Commission",
	REQUIRED_MAX_DISCOUNT: "*Max Discount amount is required",
	REQUIRED_OPA_COMMISSION: "*Opa Commission is required",
	REQUIRED_MAX_DISCOUNT_LESS_THAN_100: "*Max Discount must be less than 100",
	REQUIRED_MAX_DISCOUNT_GREATER_THAN_0: "*Max Discount must be greater than 0",
	REQUIRED_OPA_COMMISSION_GREATER_THAN_1:
		"* Opa Commission must be greater than 1",
	REQUIRED_VALID_MIN_ORDER: "*Minimum order allows only numbers",
	REQUIRED_MIN_ORDER: "*Min order value is required",
	REQUIRED_MIN_ORDER_GREATER_THAN_0: "*Minimum order must be greater than 0",
	REQUIRED_VALID_START_END_DATE: "*End date can't be before start date",

	REQUIRED_PAGE_TITLE: "*Page title is required",
	REQUIRED_META_TITLE: "*Meta title is required",
	REQUIRED_SECRET_KEY: "*Secret key is required",
	REQUIRED_GLOBAL_TAX: "*Global tax is required",
	REQUIRED_FIRST_NAME: "*First name is required.",
	REQUIRED_BRAND_NAME: "*Brand name is required.",
	REQUIRED_EMAIL_TITLE: "*Email title is required",
	REQUIRED_FILTER_NAME: "*Filter name is required",
	REQUIRED_COLUMN_NAME: "*Column name is required",
	REQUIRED_DESCRIPTION: "*Description is required",
	REQUIRED_PUBLISH_KEY: "*Publish key is required",
	REQUIRED_COUPON_NAME: "*Coupon name is required.",
	REQUIRED_CUISINE_NAME: "*Cuisine name is required",
	PROVIDE_MOBILE_NUMBER: "*Mobile number is required",
	REQUIRED_OLD_PASSWORD: "*Current password is required.",
	REQUIRED_NEW_PASSWORD: "*New password is required.",
	REQUIRED_CONFIRM_PASSWORD: "*Confirm password is required.",
	REQUIRED_MATCH_PASSWORD: "*New password & confirm passoword not match.",
	REQUIRED_VALID_PASSWORD:
		"Password must contain 8-20 characters,including uppercase,lowercase,number and a special characters[@#$%&!]",
	REQUIRED_TEMPLATE_NAME: "*Template name is required",
	REQUIRED_DISCOUNT_RATE: "*Discount rate is required",
	REQUIRED_POSITIVE_NUMBERS: "*Positive Numbers only required",
	REQUIRED_CATEGORY_NAME: "*Category name is required.",
	REQUIRED_MOOD_LABEL: "*Label is required.",
	MAX_MOOD_LABEL: "*Label must be at most 15 characters",
	PROVIDE_VALID_MOOD_LABEL: "*Special characters are not allowed in Label",
	REQUIRED_STATUS: "*Status is required.",
	REQUIRED_VALID_AMOUNT: "*Enter a valid amount",
	REQUIRED_AMOUNT: "*Amount is required",
	AMOUNT_GREATER_THAN_ZERO: "*Amount must be positive and greater than zero",
	REQUIRED_VALID_CATEGORY: "*Category name should contain at least one letter",
	REQUIRED_OPA_COMMISSION_LESS_THAN_100:
		"*Opa Commission should be greater or equal to 0% and less than 100%",
	PROVIDE_VALID_SERVICE_CHARGE:
		"*Service charge should be greater or equal to 0% and less than 100%",
	REQUIRED_SERVICE_CHARGE: "*Service charge is required",
	REQUIRED_INPUT: "Input is required",
	REQUIRED_USERNAME: "*Username is required",
	MIN_USERNAME: "*Username should contain atleast 3 characters",
	MAX_USERNAME: "*Username should contain at max 20 characters",
	VALID_USERNAME_START: "*Username cannot start with a period(.)",
	PROVIDE_VALID_USERNAME: "*no special characters except . and _ are allowed",
	REQUIRED_DOB: "*Date of birth is required",
	REQUIRED_REFERRAL_CODE: "*Referral code is required",
	MIN_REFERRAL_CODE: "*Referral Code length must be exactly 8 characters long",
	MAX_REFERRAL_CODE: "*Referral Code length must be exactly 8 characters long",
	VALID_REFERRAL_CODE:
		"*Referral Code must only contain alphanumeric characters",
	INVALID_INPUT: "Invalid input",
	REQUIRED_PROPER_EMAIL: "*Enter a valid email",
	REQUIRED_PAYOUT_CYCLE: "*Payout cycle days are required",
	PHOTO_REMOVED_SUCCESSFULLY: "Photo removed successfully",
	REQUIRED_RESTAURANT_NAME: "*Restaurant name is required.",
	REQUIRED_BUSINESS_TYPE: "*Business type is required",
	REQUIRED_REFERRAL_POINTS: "*Referral points are required",
	PHOTO_UPLOADED_SUCCESSFULLY: "Photo uploaded successfully",
	USER_UPDATED_SUCCESSFULLY: "User data updated successfully",
	REQUIRED_END_DATE_AND_TIME: "*End date & time is required.",
	REQUIRED_GLOBAL_COMMISSION: "*Global commission is required",
	REQUIRED_OPA_DEBIT_CARD_TAX: "*Opa debit card tax is required",
	REQUIRED_OPA_CREDIT_CARD_TAX: "*Opa credit card tax is required",
	REQUIRED_START_DATE_AND_TIME: "*Start date & time is required.",
	REQUIRED_WALLET_REWARD_DEBIT: "Wallet reward debit is required",
	REQUIRED_WALLET_REWARD_CREDIT: "Wallet reward credit is required",
	REQUIRED_PROPER_MOBILE_NUMBER: "*Please enter valid US number",
	REQUIRED_DEFAULT_TOP_UP_VALUES: "Default TopUp values are required",
	REQUIRED_REFERRAL_REWARD_POINT: "*Referral reward points are required",
	REQUIRED_PROPER_DISCOUNT_RATE:
		"Discount should be equal or between to 0 and 100",
	REQUIRED_PROPER_END_DATE_AND_TIME:
		"End date and time should be greater than the start date",
	REQUIRED_RESTAURANTS: "*Restaurants are required",
	PROVIDE_PROPER_PASSWORD: `* Password should contain at least a special character (@,$,& etc), a capital letter and a number and length should be between 8-20`,
	REQUIRED_FAQ_ANSWER: "Answer is required",
	REQUIRED_FAQ_QUESTION: "Question is required",
	REQUIRED_FAQ_CATEGORY: "Please select FAQ category",
	PASSWORDS_DO_NOT_MATCH: "New Password and Confirm Password does not match",
	PROMOTION_TITLE: "Promotion title is required",
	PROMOTION_TITLE_LENGTH:
		"Promotion title length should be less than 25 characters",
	PROMOTION_SUBTITLE_LENGTH:
		"Promotion subtitle length should be less than 40 characters",
	PROMOTION_BODY: "Promotion body is required",
	PROMOTION_BODY_LENGTH:
		"Promotion body length should be less than 120 characters",
	REQUIRED_NAME: "*Name is required",
	REQUIRED_VOUCHER_EXPIRE: "*Gift voucher expiry duration is required",
	VOUCHER_EXPIRE_MIN: "*Gift voucher expiry duration should be greater than 0",
	VOUCHER_EXPIRE_MAX:
		"*Gift voucher expiry duration should be less than or equal to 90",
	VOUCHER_EXPIRE_INTEGER:
		"*Gift voucher expiry duration must be a whole number",
	REQUIRED_MIN_AGE: "*Minimum age for gifting is required",
	MIN_AGE_INTEGER: "*Minimum age for gifting must be a whole number",
	REQUIRED_MASTER_ADDRESS: "*Master address for tax deductions is required",
	PARTNERSHIP_ID: "*Partnership is required",
	Lunchbox_API_Key: "*Lunchbox Api Key is required",
	Lunchbox_URL_Endpoint: "*Lunchbox URL Endpoint is required",
	STORE_NUMBER: "*Store number is required",
	MENU_ID: "*Menu ID is required",
};
